import type { BasicCustomerFragment, CompleteBookingFragment } from '@drycut/graphql';

import { Stack } from '@drycut/ui-components';
import { twJoin } from 'tailwind-merge';

import { CreditCard, Preferences, Silent } from './icons';

type Props = {
  booking: CompleteBookingFragment;
  customer: BasicCustomerFragment;
  showPreferencesIcon?: boolean;
  size?: 'large' | 'small';
};

export function CustomerBookingIcons({
  booking,
  customer,
  size = 'large',
  showPreferencesIcon = true,
}: Props): React.ReactElement {
  const defaultClasses = 'white border-2 rounded-full p-1 fill-white';
  const classesWithSize = twJoin(defaultClasses, size === 'small' ? 'size-6' : 'size-8');

  const amount = booking?.paymentTransaction?.amount || 0;
  const manual = booking?.manual || false;
  const couponUsed = !!booking?.coupon;
  const silentBooking = booking?.paymentTransaction?.data?.silentBooking || false;
  const submittedPreferences = customer?.preferences?.submittedPreferences || false;

  return (
    <Stack direction="row" className="-space-x-3">
      {manual && <CreditCard className={twJoin(classesWithSize, 'bg-rose-500 border-rose-500')} />}
      {silentBooking && (
        <Silent className={twJoin(classesWithSize, 'bg-zinc-500 border-zinc-500')} />
      )}
      {submittedPreferences && showPreferencesIcon && (
        <Preferences className={twJoin(classesWithSize, 'bg-green-400 border-green-400')} />
      )}

      {couponUsed && manual && (
        <div
          className={twJoin(
            classesWithSize,
            'flex items-center justify-center bg-sky-200 border-sky-400',
          )}
        >
          {amount}
        </div>
      )}
    </Stack>
  );
}
